import _ from "underscore";
import { CanvasHandler } from "../../handlers";
import { FabricObject } from "../../types/FabricCustomType";
import { IObjectSelector } from "../../types/HandlerObjectType";
import { getSvgObject,updateObjectStatusInDb, createObjectModel } from "../../utils/ObjectUtil";
import { TooltipSeatSelector } from "../../components/tooltip/TooltipSeatSelector";
import store from "../../redux/store";
import {
  addSeatToSelection,
  removeSeatToSelection,
} from "../../redux/designerPropertiesSlice";
import { isTouchDevice, isTouchInteraction } from "../../utils/InteractionUtil";
import { IconKey, Icons, SeatIcons } from "../../enums";
import { fabric } from 'fabric';

interface SeatCallback {
  value: number;
  status: string;
  categoryKey: string;
  category: string;
  selectorKey: string;
  row: string;
  seat: string;
  section: string;
  objectType: string;
}
class Seat implements IObjectSelector {
  private canvasHandler: CanvasHandler;
  private targetSeat!: FabricObject<Object> | null;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }

  public activateObjectHover(event: any, seat: FabricObject<Object>): any {
    if (this.targetSeat != seat) {
      this.deactivateObjectHover();//Elimina el hover del objeto anterior
      const seatCircle = seat.item(0);
      this.setTooltip(event, seat);
      if (seat.status == "Free" && seat.available) {
        const {
          properties: { rowSeatSize },
        } = store.getState();
        seatCircle.set({
          fill: `${seatCircle.stroke}90`,
          radius: (rowSeatSize/2) + 0.5,
        });
      }
      this.targetSeat = seat;
      this.canvasHandler.canvas.requestRenderAll();
    }

    if (this.targetSeat && this.targetSeat.available && this.targetSeat.status == "Free")
      this.canvasHandler.canvas.setCursor("pointer");
    else
      this.canvasHandler.canvas.setCursor("default");
  }

  public async handleSelectObject(parentKey: string, seat: FabricObject<Object>) {
    await this.changeStatus(parentKey, seat);
  }

  public async handleObjectLockUpdate(object: any, hubItem: any, selectorKey: any): Promise<any> {
    const {
      properties: { channels },
    } = store.getState();
    if (object) {
      if (hubItem.status == "Free" && ((hubItem.channel?.key ?? null) == null || channels.includes(hubItem.channel?.key ?? null))) {
        this.releaseInCanvas(object);
      } else {
        this.holdInCanvas(object, (hubItem.channel?.key ?? null) == null ? hubItem.status : "Reserved", selectorKey);
      }

      if (window.redseats.responseCallback && !isTouchDevice())
        window.redseats.responseCallback();
      else
        this.deactivateObjectHover();
    }
  }

  public deactivateObjectHover = () => {
    if (this.targetSeat) {
      this.canvasHandler.tooltipHandler.hide();
      this.canvasHandler.canvas.setCursor("default");
      if (this.targetSeat.status == "Free" && this.targetSeat.available) {
        const seatCircle = this.targetSeat.item(0);
        const {
          properties: { rowSeatSize },
        } = store.getState();
        seatCircle.set({
          fill: `${seatCircle.stroke}40`,
          radius: (rowSeatSize/2),
        });
      }
      this.canvasHandler.canvas.requestRenderAll();
      this.targetSeat = null;
    }
    else {
      this.canvasHandler.tooltipHandler.hide();
      this.canvasHandler.canvas.setCursor("default");
    }
  };

  private async changeStatus(parentKey: string, seat: FabricObject<Object>): Promise<any> {
    const {
      properties: { selection },
    } = store.getState();
    this.canvasHandler.eventHandler.panning = false;
    let seatsLength = 0;
    if (seat.available) {
      let category = selection.find((select) => {
        return seat.category.key === select.key
      });
      seatsLength = category.seats.length;
    }
    if (
      (seat.available &&
        seatsLength < window.redseats.maximumsSeatsSelected) ||
      (seat.status == "Reserved" && seat.isHoldByMe)
    ) {
      let isSuccessful = false;
      let isSelection = false;
      const objectModel = createObjectModel(parentKey, seat);
      if (seat.status == "Free") {
        isSelection = true;
        isSuccessful = await updateObjectStatusInDb([objectModel], "Reserved", true);
      } else if (seat.status == "Reserved" && seat.isHoldByMe) {
        seat.set({
          status: "Reserved",
          isHoldByMe: true,
        });
        isSuccessful = await updateObjectStatusInDb([objectModel], "Free", true);
      }

      const seatCallback = this.createSeatCallback(seat);

      if (isSuccessful) {
        if (isSelection) window.redseats.onSeatSelected(seatCallback);
        else window.redseats.onSeatDeselected(seatCallback);
      } else window.redseats.onFailedSeatSelection(seatCallback);
    }
  }

  private async holdInCanvas(seat: any, status: string, selectorKey: string) {
    const canvas = this.canvasHandler.canvas;
    const selector = JSON.parse(sessionStorage.getItem("rs_selector"));
    const isHoldByMe: boolean = selector.key == selectorKey;
    const {
      properties: { selection },
    } = store.getState();
    seat.set({
      status: status,
      isHoldByMe: isHoldByMe,
    });
    const seatCircle = seat.item(0);
    const seatText = seat.item(1);
    const colorFill = seat.statusColor[status];
    if (isHoldByMe) {
      let index = 0;
      selection.some((category, i) => {
        if (category.key === seat.category.key) {
          index = i
        }
      });
      store.dispatch(addSeatToSelection({ index, seat: seat.id }));
      seatCircle.set({
        fill: seat.statusColor.Free
      });
      seatText.set({
        visible: false,
      });

      const seatOldIcon = seat.item(2);
      if (seatOldIcon)
        seat.remove(seatOldIcon);

      const seatCheckIcon = getSvgObject(Icons.check, (seatCircle.radius * 1.7), '#ffffff');
      seatCheckIcon.set({
        angle: seatText.angle,
      });
      seat.insertAt(seatCheckIcon, 2, true);

    } else {
      seatCircle.set({
        fill: colorFill,
        stroke: "transparent",
      });
      seatText.set({
        visible: false,
      });

      const seatOldIcon = seat.item(2);
      if (seatOldIcon)
        seat.remove(seatOldIcon);
      const statusIcon = seat.statusIcon?.[status]?.toLowerCase() as IconKey;
      if (statusIcon && statusIcon in SeatIcons) {
        const size = seatCircle.radius * 1.7;
        const icon = getSvgObject(
          SeatIcons[statusIcon](size-3),
          size,
          "#ffffff"
        );
        icon.set({
          angle: seatText.angle,
        });
        seat.insertAt(icon, 2, true);
      } 
    }
    canvas.requestRenderAll();
  }

  private async releaseInCanvas(seat: any) {
    const {
      properties: { selection },
    } = store.getState();
    seat.set({
      status: "Free",
      isHoldByMe: false,
      available: true,
    });
    const seatCircle = seat.item(0);
    const seatText = seat.item(1);
    const hasSpecialIcon = (seat.accesible || seat.companion || seat.restrictedView);

    let index = 0;
    selection.some((category, i) => {
      if (category.key === seat.category.key) {
        index = i
      }
    });
    store.dispatch(removeSeatToSelection({ index, seat: seat.id }));
    const {
      properties: { rowSeatSize },
    } = store.getState();
    seatCircle.set({
      fill: `${seat.statusColor.Free}${this.canvasHandler.isInteractionEnabled ? "40" : "80"}`,
      stroke: this.canvasHandler.isInteractionEnabled ? seat.statusColor.Free : "transparent",
      radius: (rowSeatSize/2)
    });
    seatText.set({
      visible: !hasSpecialIcon && this.canvasHandler.isInteractionEnabled,
    });

    const seatCheckIcon = seat.item(2);
    if (seatCheckIcon) {
      seat.remove(seatCheckIcon);
    }

    if (hasSpecialIcon && this.canvasHandler.isInteractionEnabled) {
      if (seat.restrictedView)
        seat.insertAt(getSvgObject(Icons.restricted, (seatCircle.radius * 1.7), '#000000'), 2, true);
      else if (seat.accesible)
        seat.insertAt(getSvgObject(Icons.accesible, (seatCircle.radius * 1.7), '#000000'), 2, true);
      else if (seat.companion)
        seat.insertAt(getSvgObject(Icons.companion, (seatCircle.radius * 1.7), '#000000'), 2, true);
    }

    this.canvasHandler.canvas.requestRenderAll();
  }

  private setTooltip(event: any, seat: any) {
    const show = _.partial(this.canvasHandler.tooltipHandler.show, event.e);

    window.redseats.responseCallback = _.partial(
      this.showTooltip,
      show,
      seat,
      this,
      event
    );

    const seatCallback = this.createSeatCallback(seat);
    window.redseats.getTooltipInfo(seatCallback);
  }

  private showTooltip(
    show: any,
    seat: any,
    rowInstance: any,
    event: any,
    tooltipInfo: any
  ) {
    let handleSelectObject;
    if (isTouchInteraction(event))
      handleSelectObject = () => rowInstance.handleSelectObject(event.target.id, seat);

    const handleClose = () => {
      rowInstance.deactivateObjectHover();
    }

    window.redseats.responseCallback = _.partial(
      window.redseats.responseCallback,
      tooltipInfo
    );

    const htmlElement = TooltipSeatSelector(seat, tooltipInfo, handleSelectObject, handleClose);
    show(htmlElement);
  }

  private createSeatCallback(seat: any): SeatCallback{
    const selector = JSON.parse(sessionStorage.getItem("rs_selector"));
    return {
      value: seat.value,
      status: seat.status,
      categoryKey: seat.category.key,
      category: seat.category.name,
      selectorKey: selector.key,
      row: seat.rowLabel,
      seat: seat.label,
      section: seat.sectionLabel,
      objectType: "Seat",
    };
  }
}
export default Seat;
